import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZhihuComponent } from './simple-icons-zhihu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZhihuComponent ],
    exports:      [ SimpleIconsZhihuComponent ],
    bootstrap:    []
})
export class SimpleIconsZhihuModule {}
